export const Components = {
  Schemas: "Schemas",
  Parameters: "Parameters",
  Headers: "Headers",
  SecuritySchemas: "SecuritySchemas",
  PathItems: "PathItems",
  RequestBodies: "RequestBodies",
  Responses: "Responses",
} as const;

export const ComponentChild = {
  Header: "Header",
  Content: "Content",
  Response: "Response",
};
